export default __webpack_public_path__ + "static/media/urgentCareCenter.42f28e37.svg";